import * as React from "react";

function OtpSmsIcon(props) {
	return (
		<svg width={70} height={70} viewBox="0 0 70 70" fill="none" {...props}>
			<g clipPath="url(#prefix__clip0)">
				<path
					d="M35 70c19.33 0 35-15.67 35-35S54.33 0 35 0 0 15.67 0 35s15.67 35 35 35z"
					fill={props.color}
					fillOpacity={0.15}
				/>
				<path
					d="M46.868 12.972H23.33c-4.589 0-6.924 2.335-6.924 6.923V64.65c.567.357 1.143.7 1.731 1.024V21.8h33.751v43.857a35.016 35.016 0 001.905-1.139V19.895c0-4.588-2.335-6.923-6.925-6.923z"
					fill={props.color}
				/>
				<path
					d="M51.888 65.657V21.8h-33.75v43.874A34.837 34.837 0 0034.997 70a34.84 34.84 0 0016.89-4.343zM39.484 18.165a.807.807 0 01-.806.807h-7.156a.807.807 0 110-1.614h7.155c.445 0 .807.36.807.807z"
					fill="#fff"
				/>
			</g>
			<defs>
				<clipPath id="prefix__clip0">
					<path fill="#fff" d="M0 0h70v70H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default OtpSmsIcon;
